import { useAuth } from "../../hooks/useAuth";
import BookingsPage from "./BookingsPage";
import MultiPlaceAdminBookingsPage from "../multi-place-admin/bookings/BookingsPage";

export default function Bookings() {
  const { isMultiPlaceAdmin } = useAuth();

  if (isMultiPlaceAdmin) {
    return <MultiPlaceAdminBookingsPage />;
  }

  return <BookingsPage />;
}
